import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/about', name: 'about', component: () => import('../views/About.vue') },
  { path: '/ficha', name: 'ficha', component: () => import('../views/Ficha.vue') },
  { path: '/sucesso/:id_crip', name: 'sucesso', component: () => import('../views/Sucesso.vue') },
  { path: '/redefinir-senha/:id_crip', name: 'redefinir_senha', component: () => import('@/views/RedefinirSenha.vue') },
  { path: '/recuperacao-de-senha', name: 'senha', component: () => import('@/views/Senha.vue') },
  { path: '/cert', name: 'cert', component: () => import('@/views/Cert.vue') },
  { path: '/area-do-participante/home', name: 'dados', component: () => import('../views/area_do_participante/Dados.vue') },
  { path: '/area-do-participante/alterar-senha', name: 'alterar_senha', component: () => import('../views/area_do_participante/AlterarSenha.vue') },
  { path: '/area-do-participante/certificados', name: 'certificados', component: () => import('../views/area_do_participante/Certificados.vue') },
  // { path: '/area-do-participante/trabalhos', name: 'trabalhos', component: () => import('../views/area_do_participante/Trabalhos.vue') },
  // { path: '/area-do-participante/trabalhos-alterar/:id_crip', name: 'trabalhosalterar', component: () => import('../views/area_do_participante/TrabalhosEd.vue') },
  // { path: '/area-do-participante/trabalhos-novo', name: 'trabalhosnovo', component: () => import('../views/area_do_participante/TrabalhosNovo.vue') },
  // { path: '/area-do-participante/trabalhos-sucesso', name: 'trabalhossucesso', component: () => import('../views/area_do_participante/TrabalhosSucesso.vue') },
  { path: '/area-do-participante/status', name: 'status', component: () => import('../views/area_do_participante/Status.vue') },
  { path: '*', component: () => import('../views/404.vue') }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
